<template>
  <el-dialog title="打印" :visible.sync="dialogPrintVisible"  append-to-body :close-on-click-modal="false">
    <el-select v-model="printId" placeholder="请选择" @change="choosePrint" style="margin-bottom: 20px">
      <el-option v-for="item in printList" :key="item.id"
        :label="`${item.name} (${item.paperWidth}mm*${item.paperHeight}mm)`" :value="item.id">
      </el-option>
    </el-select>
    <el-button type="primary" style="margin-left: 50px" @click="printbatch" v-if="!isAll">打印</el-button>
    <el-button type="primary" style="margin-left: 50px" @click="printbatch" v-else>批量打印</el-button>

    <div style="margin-bottom: 10px;" v-if="companyName.includes('利佳')">
      <label>名称输入：</label>
      <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    </div>
    <div style="margin-bottom: 10px;" v-if="companyName.includes('利佳')">

      <label>件(图)号输入：</label>
      <el-input v-model="inputPartNumber" placeholder="请输入件(图)号" style="width: 200px;"></el-input>
    </div>
    <!--    @click="printbatch"-->
    <!--    <div id="printCode" >-->
    <!--      <div v-for="(item,index) in printDataList" :key="index" style="overflow: hidden">-->
    <!--        <print-model :handle="item.handle" :title="item.title" :name="item.name" :companyName="companyName"-->
    <!--                     :paperWidth="paperWidth" :paperHeight="paperHeight" :codeWidth="codeWidth"-->
    <!--                     :classHeight="item.classHeight"></print-model>-->
    <!--      </div>-->

    <!--    </div>-->
    <div id="printAll">
      <div v-for="(item,index) in printDataList" :key="index" :id="'printItem'+index"
        :style="`width: ${paperWidth}mm ;height: ${paperHeight-0.3}mm;page-break-after: always;display:flex;align-items: center;justify-content: center;`">
        <!--        <div-->
        <!--            style="text-align: center;color: black;border-bottom: 0.4mm black solid;"-->
        <!--            :style="{'height':paperHeight*0.2+'mm','line-height': paperHeight*0.2+'mm','font-size':paperWidth*0.05+'mm'}">-->
        <!--          {{ companyName }}-->
        <!--        </div>-->
        <!-- 利佳 -->
        <div style="display: flex;flex-direction: column;"
          :style="`width: ${paperWidth}mm;height: ${paperHeight-0.3}mm;page-break-after: always;margin:0 auto;`"
           v-if="item.name && (companyName.includes('利佳'))">
          <div style="margin-bottom: 2mm;"
            :style="`width: ${paperWidth}mm;height: ${paperHeight-0.3}mm;page-break-after: always;margin:0 auto;`">
            <table style="width: 100%; border-collapse: collapse;"
              :style="{ 'font-size': Math.min(paperWidth * 0.04, 6) + 'mm', 'width': paperWidth+'mm', 'height': paperHeight-0.3+'mm'}">
              <!-- 设置最大字体大小为 6mm -->
              <tr>
                <td style="border: 0.1mm solid #000; padding: 1.5mm;">名称</td> <!-- 减少内边距 -->
                <td style="border: 0.1mm solid #000; padding: 1.5mm;" v-if="!companyName.includes('云锐')">{{name?name:
                  splitNameAndPartNumber(item.name).name}}</td>
                  <td style="border: 0.1mm solid #000; padding: 1.5mm;" v-else>{{item.name}}</td>
                <!-- 减少内边距 -->
                <td rowspan="2" style="border: 0.1mm solid #000; padding: 1.5mm;">
                  <vue-qr :size="1000" :margin="0" :auto-color="true" :dot-scale="1"
                    :text="`${codeUrl}?h=${item.handle}`" class="codeImage"
                    :style="`width: ${codeWidth}mm;  display: block; margin: auto; max-width: 100%; max-height: 100%;`" />
                </td>
              </tr>
              <tr>
                <td style="border: 0.1mm solid #000; padding: 1.5mm;white-space: nowrap;">件(图)号</td> <!-- 减少内边距 -->
                <td style="border: 0.1mm solid #000; padding: 1.5mm;" v-if="!companyName.includes('云锐')">{{ inputPartNumber ? inputPartNumber :
                  splitNameAndPartNumber(item.name).partNumber }}</td>
                  <td style="border: 0.1mm solid #000; padding: 1.5mm;" v-else>{{ item.partNumber }}</td>
              </tr>
              <tr>
                <td :style="`width: ${codeWidth*0.8}mm ;border: 0.1mm solid #000; padding: 1.5mm;white-space: nowrap;`">
                  识别码</td>
                <!-- 减少内边距 -->
                <!-- <td style="border: 0.1mm solid #000; padding: 1.5mm;">{{ item.handle }}</td>  -->
                <td :style="`border: 0.1mm solid #000; padding: 1.5mm;`">{{item.handle}}</td> <!-- 减少内边距 -->
                <td style="border: 0.1mm solid #000; padding: 1.5mm;">
                  <!-- 保证区位二字不换行 -->
                  <span style="">区位:{{ (item.warehouseName || '').split('/')[2] || '' }}</span>
                </td>
              </tr>
              <tr>
                <td style="border: 0.1mm solid #000; padding: 1.5mm;">仓库</td> <!-- 减少内边距 -->
                <td style="border: 0.1mm solid #000; padding: 1.5mm;">{{ (item.warehouseName || '').split('/')[0] || ''
                  }}</td>
                <td style="border: 0.1mm solid #000; padding: 1.5mm;">
                  <!-- 保证库区二字不换行 -->
                  <span style="white-space: nowrap;">库区:{{ (item.warehouseName || '').split('/')[1] || '' }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- 五洲 -->
        <div v-else-if="companyName.includes('五洲') || companyName.includes('云锐')">
          <div style="display: flex;flex-direction: column;"
            :style="`width: ${(paperWidth)-4}mm;height: ${(paperHeight)-4}mm;border:0.1mm black solid;page-break-after: always;margin:0 auto;`"
            v-if="item.name">
            <div
              style="font-weight: 600;border-bottom: 0.4mm #000 solid;text-align: center;justify-content: center;align-content:center;container-type: inline-size;"
              :style="{'height':paperHeight*0.3+'mm'}">
              <p :style="`${styleFormate(index)}`" :ref="`txtRef-${index}`" style="display: inline-block;">{{
                item.name }}</p>
            </div>
            <div style="text-align: center;margin-top: 1mm;justify-content: center;align-content:center"
              :style="{'height':paperHeight*0.75+'mm'}">
              <vue-qr :size="1000" :margin="0" :auto-color="true" :dot-scale="1" :text="`${codeUrl}?h=${item.handle}`"
                class="codeImage"
                :style="`width: ${codeWidth}mm;height: ${codeWidth}mm;display: block;margin: 0 auto`" />
              <div v-if="item.warehouseName" style="font-size: 12px;font-weight: 500;margin-top: 1mm;"
                :style="{'font-size':paperWidth*0.05+'mm'}">{{ item.name ? item.warehouseName : ''}}</div>
            </div>
          </div>
          <div v-else>
            <vue-qr :size="1000" :margin="0" :auto-color="true" :dot-scale="1" :text="`?h=${item.handle}`"
              class="codeImage"
              :style="`width: ${paperHeight - 4}mm;height: ${paperHeight - 4}mm;display: block;margin: 0 auto;`" />
          </div>
        </div>

        <div v-else>
          <div style="display: flex;flex-direction: column;"
            :style="`width: ${(paperWidth)-4}mm;height: ${(paperHeight)-4}mm;border:0.1mm black solid;page-break-after: always;margin:0 auto;`"
            v-if="item.name">
            <div style="text-align: center;margin-top: 1mm;justify-content: center;align-content:center;border-bottom: 0.4mm #000 solid;"
              :style="{'height':paperHeight*0.75+'mm'}">
              <vue-qr :size="1000" :margin="0" :auto-color="true" :dot-scale="1" :text="`${codeUrl}?h=${item.handle}`"
                class="codeImage"
                :style="`width: ${codeWidth}mm;height: ${codeWidth}mm;display: block;margin: 0 auto`" />
              <div v-if="item.warehouseName" style="font-size: 12px;font-weight: 500;margin-top: 1mm;"
                :style="{'font-size':paperWidth*0.05+'mm'}">{{ item.name ? item.warehouseName : ''}}</div>
            </div>
            <div
              style="font-weight: 600;text-align: center;justify-content: center;align-content:center;container-type: inline-size;"
              :style="{'height':paperHeight*0.3+'mm'}">
              <p :style="`${styleFormate(index)}`" :ref="`txtRef-${index}`" style="display: inline-block;">{{
                item.name }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </el-dialog>
</template>
<script>
  import { selectAllPrintList } from '@/api/storeCodePrint.js'
  import { selectCodeList, selectCodeDetailList, selectPrintCode ,selectList,updataStatus} from '@/api/storeCode.js'
  import print from 'vue-print-nb'
  import PrintModel from "./PrintModel.vue";
  import VueQr from 'vue-qr'
  import { codeUrl } from '@/utils/constant'
  export default {
    directives: { print },
    data() {
      return {
        codeUrl: codeUrl,
        barcode_option: {
          displayValue: false,
        },
        userInfo: '',
        companyName: '',
        codeWidth: 50,
        classHeight: 6,
        list: [],
        dialogPrintVisible: false,
        printId: '',
        printList: [],
        paperWidth: 70,
        paperHeight: 30,
        printDataList: [],
        isAll: false,
        printData: {},
        marginsWidth: 6,
        marginsHeight: 4,
        // 新增字段：输入框绑定的件号值
        inputPartNumber: '',
        name: '',
        storeCodeIds:[]
      }
    },
    components: { VueQr },
    props: {},
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }
    },
    mounted() {
      this.getAllPrint()
    },
    watch: {
      inputPartNumber(newVal) {
        this.inputPartNumber = newVal;
      },
      name(newVal) {
        this.name = newVal;
      }
    },
    methods: {
      splitNameAndPartNumber(str) {
        const nameMatch = str.match(/[\u4e00-\u9fa5]+/g);
        const name = nameMatch ? nameMatch.join('') : '';
        const partNumber = str.replace(name, '');
        return { name, partNumber };
      },
      styleFormate(index) {
        this.$nextTick(() => {
          const refObj = `txtRef-${index}`;
          const dom = (this.$refs[refObj]);
          const width = dom[0].clientWidth;
          let fontHeight = dom[0].clientHeight;
          let parentWidth = dom[0].parentNode.clientWidth;
          const parentHeight = dom[0].parentNode.clientHeight;
          const multNum = (parentWidth) / width;
          let num = Math.floor(multNum * 100) / 100;
          while (parseFloat((width * num).toFixed(2)) < parentWidth * 0.7) {
            num = parseFloat((num * 1.05).toFixed(2))
          }
          if (multNum > 1) {
            while (parseFloat((width * num).toFixed(2)) > parentWidth * 0.8) {
              num = parseFloat((num * 0.95).toFixed(2))
            }
          }
          while (parseFloat((fontHeight * num).toFixed(2)) > parentHeight * 0.8) {
            num = parseFloat((num * 0.95).toFixed(2))
          }
          const style = `transform:scale(${num});display: inline-block`;
          dom[0].style = style;
        });
      },
      init(batchId, codeId, type, warehouseId,selectedIds) {
        if ('all' == type) {
          console.log('打印所有', selectedIds)
          this.isAll = true
          if (name) {
            this.warehouseName = name
          }
          this.inputPartNumber = ''
          this.name = ''
          console.log("selectedIds",selectedIds);
          let codeList=selectedIds
          this.getPrint(codeList)
        } else {
          this.isAll = false
          if (name) {
            this.warehouseName = name
          }
          this.inputPartNumber = ''
          this.name = ''
          this.getPrintData(batchId, codeId, warehouseId)
        }
      },
      initSize() {
        // this.codeWidth = parseInt((this.paperWidth * 0.4))
        // if (this.codeWidth > this.paperHeight - 14) {
        //   this.codeWidth = parseInt((this.paperHeight - 15))
        // }
        // this.printDataList.forEach(item => {
        //   var lineHeight = parseInt((this.paperHeight - 14) / (item.storeCodeDetailVos.length));
        //   if (lineHeight > 0) {
        //     item.classHeight = lineHeight
        //   }
        // })
        this.codeWidth = parseInt(this.paperWidth)
        if (this.codeWidth > (this.paperHeight - this.marginsWidth) * 0.6) {
          this.codeWidth = parseInt((this.paperHeight - this.marginsHeight) * 0.5)
        }
        this.printDataList.forEach(item => {
          var lineHeight = parseInt((this.paperHeight - this.marginsHeight) * 0.6);
          if (lineHeight > 0) {
            item.classHeight = lineHeight
          }
        })
      },
      choosePrint() {
        // this.timer = new Date().getTime();
        let fe = this.printList.filter(item => {
          return item.id == this.printId
        })
        if (fe) {
          this.paperWidth = fe[0].paperWidth
          this.paperHeight = fe[0].paperHeight
        }
        this.initSize()
      },
      getAllPrint() {
        selectAllPrintList().then(res => {
          this.printList = res.data
          if (this.printList && this.printList.length > 0) {
            this.printId = this.printList[0].id
            this.choosePrint()
          }
        })
      },
      getPrintData(batchId, codeId, warehouseId) {
        selectPrintCode({ batchId: batchId, codeId: codeId, warehouseId: warehouseId }).then(res => {
          console.log('aaa', res)
          this.printDataList = res.data
          this.printDataList.forEach(item => {
          this.storeCodeIds.push(item.id);
        });
          
          this.initSize()
          this.dialogPrintVisible = true
        })
      },  
      getPrint(codeList) {
        this.storeCodeIds = []
        codeList.forEach(id => {
          this.storeCodeIds.push(id);
        });
        let param = {
          storeCodeIds: [...this.storeCodeIds],
        }
        selectList(param).then(res => {
          console.log("打印数据", res);
          this.printDataList = res.data
          this.initSize()
          this.dialogPrintVisible = true
        })
      },
      printbatch() {
        console.log(this.storeCodeIds);
        let param = {
          storeCodeIds: [...this.storeCodeIds],
        }
        updataStatus(param).then(res => {
          const printStyle = `<style>@media print{body{margin: 0; padding: 0;}}</style>`;
          var newWin = window.open(""); //新打开一个空窗口
          for (var i = 0; i < this.printDataList.length; i++) {
            var imageToPrint = document.getElementById("printItem" + i); //获取需要打印的内容
            newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
          }
          newWin.document.head.innerHTML = printStyle; //给打印的内容加上样式
          newWin.document.close(); //在IE浏览器中使用必须添加这一句
          newWin.focus(); //在IE浏览器中使用必须添加这一句
          setTimeout(function () {
            newWin.print(); //打印
            newWin.close(); //关闭窗口
          }, 100);
        })
      }
    }
  }
</script>
<style scoped>
  @page {
    size: auto;
    margin: 0mm;
  }

  tr td {
    word-break: keep-all;
  }
</style>